import { render, staticRenderFns } from "./advisory-finish.vue?vue&type=template&id=71e904ad&"
import script from "./advisory-finish.vue?vue&type=script&lang=js&"
export * from "./advisory-finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports